import React from 'react'

import { LoadingTripleSpinner } from '@frame/ui-components/loading-triple-spinner'
import { H4 } from '@frame/ui-primitives/h4'
import { P } from '@frame/ui-primitives/p'

export function WaitingForInstantDataContent() {
  return (
    <div className="relative bottom-6 flex h-full flex-col items-center justify-center">
      <LoadingTripleSpinner />
      <H4 className="mb-1 mt-6">Searching Instant Records...</H4>
      <P variant="small" className="text-center">
        Please stay on this page while we attempt to process an Instant verification
      </P>
    </div>
  )
}
